import { cn } from '@/lib/utils';
import type { BlogPostStatus } from '../types';
import { BLOG_STATUS_LABELS, blogStatusLabel, editorStatusValue } from '../lib/statusLabels';

const STYLES: Record<BlogPostStatus, string> = {
    draft: 'bg-zinc-500/15 text-zinc-600 dark:text-zinc-300 border-zinc-500/20',
    review: 'bg-amber-500/15 text-amber-800 dark:text-amber-300 border-amber-500/25',
    enabled: 'bg-emerald-500/15 text-emerald-800 dark:text-emerald-300 border-emerald-500/25',
    disabled: 'bg-zinc-500/15 text-zinc-600 dark:text-zinc-300 border-zinc-500/20',
};

export function BlogStatusBadge({
    status,
    size = 'md',
    className,
}: {
    status?: string | null;
    size?: 'sm' | 'md';
    className?: string;
}) {
    const key = editorStatusValue(status);
    const styleKey = (status && status in BLOG_STATUS_LABELS ? status : key) as BlogPostStatus;
    return (
        <span
            data-blog-status={styleKey}
            className={cn(
                'inline-flex items-center rounded-full border font-medium',
                size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
                STYLES[styleKey],
                className,
            )}
        >
            {blogStatusLabel(styleKey)}
        </span>
    );
}
